import type {
  CheckoutFontWeights,
  CheckoutLineHeights,
  FontFaceDefinitions,
  Fonts,
  FontSizes,
  FontSizeScale,
  FontWeights,
  LineHeights,
} from '@trmediaab/zebra';
import { appendPx } from '@trmediaab/zebra';

import sizes from './sizes';

const regular = 400;
const semiBold = 600;
const bold = 700;
const extraBold = 800;

export const fontWeights: FontWeights & CheckoutFontWeights = {
  base: regular,
  regular,
  medium: regular,
  semiBold,
  bold,
  extraBold,
};

export const fonts: Fonts = {
  primary: [
    'Open Sans',
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    'Fira Sans',
    'Droid Sans',
    'Helvetica',
    'Helvetica Neue',
    'Arial',
    'sans-serif',
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
  ]
    .map(font => `'${font}'`)
    .join(', '),
  decorative: ['Caveat', 'cursive', 'serif']
    .map(font => `'${font}'`)
    .join(', '),
};

export const fontFaceDefinitions: FontFaceDefinitions = [
  {
    source: 'google',
    familyPath: 'Open+Sans:ital,wght@0,400;0,600;0,700;0,800;1,400',
  },
  {
    source: 'google',
    familyPath: 'Caveat:wght@700',
  },
];

const fontSizesScale: FontSizeScale = {
  0: 12,
  1: 14,
  2: 16,
  3: 18,
  4: 20,
  5: 22,
  6: 26,
  7: 32,
  8: 44,
};

export const fontSizes: FontSizes = {
  ...fontSizesScale,
  base: fontSizesScale[2],
  quoteSign: 80,
};

export const lineHeights: LineHeights & CheckoutLineHeights = {
  base: 1.5,
  double: 2,
  medium: 1.25,
  tight: 1.05,
  buttonHeights: appendPx(sizes.buttonHeights),
};
